import { cliente } from '@/lib/cliente';
import type { GuardarHoras, NominaSemanal, Subcontrato } from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useNomina() {
  return useQuery({ queryKey: ['mo', 'nomina'], queryFn: () => cliente.mo.nomina() });
}
export function useGuardarNomina() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (
      body: Omit<NominaSemanal, 'anio' | 'numero_semana' | 'fecha_inicio' | 'fecha_fin'>,
    ) => cliente.mo.guardarNomina(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mo', 'nomina'] }),
  });
}

export function useHoras() {
  return useQuery({ queryKey: ['mo', 'horas'], queryFn: () => cliente.mo.horas() });
}
export function useGuardarHoras() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: GuardarHoras) => cliente.mo.guardarHoras(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mo', 'horas'] }),
  });
}

export function useSubcontratos() {
  return useQuery({ queryKey: ['mo', 'subcontratos'], queryFn: () => cliente.mo.subcontratos() });
}
export function useCrearSubcontrato() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Omit<Subcontrato, 'id'>) => cliente.mo.crearSubcontrato(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mo', 'subcontratos'] }),
  });
}
export function useEliminarSubcontrato() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => cliente.mo.eliminarSubcontrato(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mo', 'subcontratos'] }),
  });
}

/** M.O. acumulada por obra — todo el histórico registrado (nómina prorrateada + subcontratos). */
export function useReporteAcumuladoMO() {
  return useQuery({
    queryKey: ['mo', 'reporte-acumulado'],
    queryFn: () => cliente.mo.reporteAcumulado(),
  });
}
